import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function useVelocityTheme() {
    var scThemeContext = useContext(ThemeContext);
    return scThemeContext.velocity;
}
//# sourceMappingURL=useVelocityTheme.js.map